import { Injectable, ErrorHandler } from '@angular/core';
import { Router } from '@angular/router';
import { AngularPlugin } from '@microsoft/applicationinsights-angularplugin-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { getAppConfig } from 'src/app.config';

const appSettings = getAppConfig() as any;

@Injectable({
  providedIn: 'root'
})
export class InsightsService {
  private angularPlugin = new AngularPlugin();
  private appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: appSettings["appconfig"]["instrumentationKey"],
      extensions: [this.angularPlugin],
      extensionConfig: {
        [this.angularPlugin.identifier]: {
          router: this.router,
          errorServices: [new ErrorHandler()]
        }
      }
    }
  });

  constructor(private router: Router) {
    this.appInsights.loadAppInsights();
  }

  // expose methods that can be used in components and services
  trackEvent(name: string, properties?: { [key: string]: any }): void {
    if (!properties && localStorage.getItem('email'))
      // when properties is undefined create with userEmail
      properties = { userEmail: localStorage.getItem('email') };
    else if (properties && localStorage.getItem('email'))
      // when properties is there set with userEmail
      properties['userEmail'] = localStorage.getItem('email');

    this.appInsights.trackEvent({ name }, properties);
  }

  trackTrace(message: string, properties?: { [key: string]: any }): void {
    this.appInsights.trackTrace({ message }, properties);
  }

  logError(error: any) {
    this.appInsights.trackException({ exception: error });
  }
}
